// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboutMe_wrapper__2dUB5","line_wrapper":"AboutMe_line_wrapper__22GwY","line":"AboutMe_line__GwZ2o","circle":"AboutMe_circle__XS0NQ","title":"AboutMe_title__1vt3Q"};